import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../../components/Form/Field'

import { selectedPartnershipSelector } from '../../../../../../../../modules/selectors/partnerships'

import { NAME, RIGHT_TYPE, RIGHT_TYPE_DIGITAL } from '../../../../fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

function NameSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()
  const { t } = useTranslation()

  const { rights_holder_name: rightsHolderName } = useSelector(selectedPartnershipSelector)

  const { values } = formik

  const isDigitalType = values[RIGHT_TYPE] === RIGHT_TYPE_DIGITAL

  return (
    <section className={drawerFormClasses.section}>
      <div className={drawerFormClasses.tabsContainer}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Right name')}</h3>
      </div>
      {isDigitalType ? (
        <p>
          Campaigns across ad platforms will use the right name you set below. Please choose a suitable name like “
          {rightsHolderName} audience targeted campaign” or “Spring 2023 social”.
        </p>
      ) : (
        <p>Please give the right a descriptive name that will be clear to the partner.</p>
      )}
      <Field
        placeholder="Name of right"
        formik={formik}
        name={NAME}
        enableReinitialize
        autoComplete="off"
        disablePlaceholderFormatting
      />
    </section>
  )
}

export default NameSection
